<template>
  <section class="page-dashbord-goals mt-3">
    <app-loading :isFull="true" v-if="isLoading" />
    <vue-modaltor
      :visible="isQuestion"
      @hide="hideModal"
      :default-width="'60%'"
      :bg-overlay="'rgba(0, 0, 0, 0.7)'"
      :resize-width="{1200:'60%',992:'80%',768:'90%'}"
    >
      <form class="row" @submit.prevent data-vv-scope="add">
        <div class="col-6 m-auto">
          <div class="group-form">
            <input
              type="text"
              v-validate="'required'"
              name="add.newQ"
              :class="{active:newQ != '' }"
              v-model="newQ"
            />
            <span class="bar"></span>
            <label class="statr">سوال را وارد کنید</label>
            <span v-if="errors.has('add.newQ')" class="is-danger">فیلد نباید خالی باشد</span>
          </div>
        </div>
        <div class="col-3">
          <!-- @click="addQuestion" -->
          <button
            class="font-16 px-5 mt-3 py-2 bttn-fill bttn bttn-success"
            v-ripple
            @click="addQuestion('add')"
          >ذخیره سوال</button>
        </div>
      </form>
    </vue-modaltor>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <header class="text-right mb-4">
            <h1 class="font-20">اهداف دوره</h1>
          </header>
        </div>
      </div>
      <form @submit.prevent data-vv-scope="save" class="wrapper-form row shadow py-4 mb-5">
        <div class="col-6" v-for="(item,index) in course_goals" :key="index">
          <!-- <span class="d-block text-right mb-4 clearfix">{{item.question}}</span> -->
          <div class="group-form">
            <input
              type="text"
              v-validate="'required'"
              :name="'a'+index"
              :class="{active:item.question != '' }"
              v-model="item.question"
            />
            <span class="bar"></span>
            <label class="statr">سوال</label>
            <span v-if="errors.has('save.a'+index)" class="is-danger">فیلد نباید خالی باشد</span>
          </div>
          <div class="group-form">
            <textarea
              type="text"
              v-validate="'required'"
              :name="'q'+index"
              :class="{active:item.answer != '' }"
              v-model="item.answer"
            ></textarea>
            <span class="bar"></span>
            <label class="statr">جواب</label>
            <span v-if="errors.has('save.q'+index)" class="is-danger">فیلد نباید خالی باشد</span>
          </div>
        </div>
        <div class="col-12">

        <button
          class="font-16 px-5 py-2 bttn-fill bttn bttn bttn-primary"
          v-ripple
          @click="openModal"
        >سوال جدید مطرح کنید +</button>
        </div>
        <div class="col-12">
          <div class="form-action text-left">
            <button
              v-if="course_goals.length && course_goals[0].id"
              class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-ripple
              @click="update('save')"
            >بروزرسانی اهداف</button>
            <button
              v-else
              class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-ripple
              @click="submitForm('save')"
            >ذخیره</button>
          </div>
        </div>
        <div class="col-12">
          <controller-curose>
            <router-link class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-ripple to="/dashboard/messages">
              رفتن به مرحله بعد
            </router-link>
          </controller-curose>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: "page-dashbord-goals",
  data() {
    return {
      course_goals: [
        { question: "پیش نیاز های دوره؟", answer: "" },
        { question: "مخاطبان دوره چه کسانی هستند؟", answer: "" },
        {
          question: "بعد از اتمام دوره مخاطبین چه چیزی خواهند آموخت؟",
          answer: ""
        }
      ],
      isQuestion: false,
      newQ: "",
      isLoading: true
    };
  },
  mounted() {
    if (localStorage && !this.hasCourse().id) {
      this.$root.showWarnMsg({
        message: "شما دوره ی جدیدی تعریف نکرده اید ..."
      });
      this.$router.push({ name: "courseForm" });
      return;
    }
    this.getGoals();
  },
  methods: {
    async getGoals() {
      try {
        let { data } = await axios.post("/course-goals/get", {
          course_id: this.hasCourse().id
        });
        if (data.state !== 200) return;
        if (data.goals.length > 0) {
          this.course_goals = data.goals;
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async submitForm(scope) {
      let result = await this.$validator.validateAll(scope);
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.isLoading = true;
      await this.$store.dispatch("dashboardGoals/saveGoals", {
        course_goals: this.course_goals,
        course_id: parseInt(this.hasCourse().id)
      });
      this.isLoading = false;
    },
    async update(scope) {
      let result = await this.$validator.validateAll(scope);
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.isLoading = true;
      this.$store.dispatch("dashboardGoals/updateGoals", {
        course_goals: this.course_goals,
        course_id: parseInt(this.hasCourse().id)
      });
      this.isLoading = false;
    },
    openModal() {
      this.isQuestion = true;
    },
    async addQuestion(scope) {
      let result = await this.$validator.validateAll(scope);
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.course_goals.push({
        id: 0,
        name: "q" + this.course_goals.length + 1,
        question: this.newQ,
        answer: ""
      });
      this.hideModal();
    },
    hideModal() {
      this.isQuestion = false;
      this.newQ = "";
      this.$validator.reset();
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-goals {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/goals.vue